import { Price } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { t } from '@translations';

export type PriceFormatConfig = {
  skipEmptyPrices?: boolean;
};

export const formatPrice = (price?: Price | null) => {
  if (!price) {
    return '';
  }
  // TODO [AS]: use document.documentElement.lang instead of 'no'?
  const formatter = new Intl.NumberFormat('no', { style: 'currency', currency: price?.currency });
  const formattedPrice = formatter.format(price?.amount);
  return formattedPrice;
};

export const getTaxInformation = (price?: Price | null) => {
  if (price == null || price?.withTaxes == null) {
    return '';
  }
  const taxInformation = price?.withTaxes
    ? t(TextCodes.Product.Money.IncludeTaxes)
    : t(TextCodes.Product.Money.ExcludeTaxes);
  return taxInformation;
};

export const calculateTotalPrice = (price: number, quantity: number) => {
  return Math.round(price * quantity * 100) / 100;
};
